// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"1ca73f8d","488":"feefe78b","493":"72951745","509":"9e37e59b","743":"13fcfd58","773":"7b60d239","842":"cebc55a2","934":"48d2c556"}[chunkId] + ".chunk.js";
};